import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { Heart, MessageCircle, Bookmark, MoreHorizontal } from 'lucide-react';
import { ImageWithFallback } from '../components/ImageWithFallback';
import TrendingRestaurants from '../components/TrendingRestaurants';
import SeasonalHighlights from '../components/SeasonalHighlights';
import InstagramFeed from '../components/InstagramFeed';
import MostPhotographed from '../components/MostPhotographed';
import { useFavorites } from '../contexts/FavoritesContext';

function FoodFeed({ user }) {
  const [filter, setFilter] = useState('all');
  const { addFavorite, removeFavorite, isFavorite } = useFavorites();

  const handleFavoriteToggle = (post) => {
    if (isFavorite(post.id)) {
      removeFavorite(post.id);
    } else {
      addFavorite({
        id: post.id,
        dishName: post.dishName,
        restaurant: post.restaurant,
        location: post.location,
        rating: post.rating,
        image: post.image,
        savedAt: 'Just now',
      });
    }
  };

  const posts = [
    {
      id: '1',
      dishName: 'Neapolitan Pizza',
      restaurant: 'Pizzeria Locale',
      location: 'Brooklyn, NY',
      rating: 4.8,
      image: 'https://images.unsplash.com/photo-1761315632188-92f38ca6297d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxnb3VybWV0JTIwcGl6emElMjBzbGljZXxlbnwxfHx8fDE3NjQwOTcxNTd8MA&ixlib=rb-4.1.0&q=80&w=1080',
      author: 'Sarah Chen',
      authorInitials: 'SC',
      likes: 142,
      comments: 23,
      postedTime: '2h ago',
      aspectRatio: 'square',
    },
    {
      id: '2',
      dishName: 'Tonkotsu Ramen',
      restaurant: 'Ippudo',
      location: 'Manhattan, NY',
      rating: 4.9,
      image: 'https://images.unsplash.com/photo-1627900440398-5db32dba8db1?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyYW1lbiUyMGJvd2wlMjBub29kbGVzfGVufDF8fHx8MTc2NDA5NzE1N3ww&ixlib=rb-4.1.0&q=80&w=1080',
      author: 'Michael Park',
      authorInitials: 'MP',
      likes: 218,
      comments: 45,
      postedTime: '4h ago',
      aspectRatio: 'square',
    },
    {
      id: '3',
      dishName: 'Wagyu Ribeye',
      restaurant: 'Prime Cut',
      location: 'Chicago, IL',
      rating: 5.0,
      image: 'https://images.unsplash.com/photo-1676471912422-defa79bd178c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxmaW5lJTIwZGluaW5nJTIwc3RlYWt8ZW58MXx8fHwxNzY0MDk3MTU3fDA&ixlib=rb-4.1.0&q=80&w=1080',
      author: 'James Wilson',
      authorInitials: 'JW',
      likes: 324,
      comments: 67,
      postedTime: '6h ago',
      aspectRatio: 'landscape',
    },
    {
      id: '4',
      dishName: 'Classic Burger & Fries',
      restaurant: 'The Burger Joint',
      location: 'Austin, TX',
      rating: 4.7,
      image: 'https://images.unsplash.com/photo-1700916536887-95b4742b6dd6?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxidXJnZXIlMjBmcmllcyUyMHdvb2RlbnxlbnwxfHx8fDE3NjQwOTcxNTh8MA&ixlib=rb-4.1.0&q=80&w=1080',
      author: 'Emma Rodriguez',
      authorInitials: 'ER',
      likes: 189,
      comments: 34,
      postedTime: '8h ago',
      aspectRatio: 'square',
    },
    {
      id: '5',
      dishName: 'Thai Green Curry',
      restaurant: 'Bangkok Spice',
      location: 'San Francisco, CA',
      rating: 4.8,
      image: 'https://images.unsplash.com/photo-1679279726937-122c49626802?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjdXJyeSUyMHJpY2UlMjBib3dsc3xlbnwxfHx8fDE3NjQwOTcxNTh8MA&ixlib=rb-4.1.0&q=80&w=1080',
      author: 'David Kim',
      authorInitials: 'DK',
      likes: 156,
      comments: 28,
      postedTime: '12h ago',
      aspectRatio: 'portrait',
    },
    {
      id: '6',
      dishName: 'Garden Fresh Salad',
      restaurant: 'Green Leaf Cafe',
      location: 'Portland, OR',
      rating: 4.6,
      image: 'https://images.unsplash.com/photo-1599021419847-d8a7a6aba5b4?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxjb2xvcmZ1bCUyMHNhbGFkJTIwcGxhdGV8ZW58MXx8fHwxNzY0MDk3MTU4fDA&ixlib=rb-4.1.0&q=80&w=1080',
      author: 'Olivia Martinez',
      authorInitials: 'OM',
      likes: 97,
      comments: 15,
      postedTime: '1d ago',
      aspectRatio: 'square',
    },
    {
      id: '7',
      dishName: 'Street Tacos',
      restaurant: 'La Taqueria',
      location: 'Los Angeles, CA',
      rating: 4.9,
      image: 'https://images.unsplash.com/photo-1707603571504-86c1ea50903e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx0YWNvcyUyMG1leGljYW4lMjBmb29kfGVufDF8fHx8MTc2NDA0NDczMHww&ixlib=rb-4.1.0&q=80&w=1080',
      author: 'Carlos Sanchez',
      authorInitials: 'CS',
      likes: 203,
      comments: 41,
      postedTime: '1d ago',
      aspectRatio: 'landscape',
    },
    {
      id: '8',
      dishName: 'Fine Dining Experience',
      restaurant: 'Maison Rouge',
      location: 'Seattle, WA',
      rating: 5.0,
      image: 'https://images.unsplash.com/photo-1759419038843-29749ac4cd2d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyZXN0YXVyYW50JTIwaW50ZXJpb3IlMjBlbGVnYW50fGVufDF8fHx8MTc2Mzk5NTExOHww&ixlib=rb-4.1.0&q=80&w=1080',
      author: 'Sophie Laurent',
      authorInitials: 'SL',
      likes: 445,
      comments: 89,
      postedTime: '2d ago',
      aspectRatio: 'landscape',
    },
  ];

  return (
    <div className="container mx-auto px-8">
      {/* Hero Section */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center mb-20 pt-8"
      >
        <div className="w-1 h-20 bg-border mx-auto mb-8"></div>
        <h1 className="serif text-7xl mb-6">Food Feed</h1>
        <p className="text-muted-foreground max-w-2xl mx-auto leading-relaxed">
          Latest culinary discoveries from our community of food enthusiasts
        </p>
      </motion.div>

      {/* Filters */}
      <div className="flex items-center justify-center gap-8 mb-16 border-t border-b border-border py-6">
        {[
          { id: 'all', label: 'All Posts' },
          { id: 'following', label: 'Following' },
          { id: 'featured', label: 'Featured' },
        ].map((filterOption) => (
          <button
            key={filterOption.id}
            onClick={() => setFilter(filterOption.id)}
            className={`
              text-sm uppercase tracking-widest transition-colors relative pb-1
              ${filter === filterOption.id 
                ? 'text-foreground' 
                : 'text-muted-foreground hover:text-foreground'
              }
            `}
          >
            {filterOption.label}
            {filter === filterOption.id && (
              <motion.div
                layoutId="filterIndicator"
                className="absolute -bottom-6 left-0 right-0 h-px bg-foreground"
                transition={{ type: 'spring', bounce: 0, duration: 0.4 }}
              />
            )}
          </button>
        ))}
      </div>

      {/* Masonry Grid */}
      <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8 mb-20">
        {posts.map((post, index) => (
          <motion.article
            key={post.id}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.05 }}
            className="break-inside-avoid group"
          >
            {/* Image Container */}
            <Link to={`/dish/${post.id}`} className="block relative overflow-hidden mb-4">
              <ImageWithFallback
                src={post.image}
                alt={post.dishName}
                className={`
                  w-full object-cover transition-transform duration-700 group-hover:scale-105
                  ${post.aspectRatio === 'square' ? 'aspect-square' : ''}
                  ${post.aspectRatio === 'portrait' ? 'aspect-[3/4]' : ''}
                  ${post.aspectRatio === 'landscape' ? 'aspect-[16/9]' : ''}
                `}
              />
              
              {/* Rating Overlay */}
              {post.rating && (
                <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-md">
                  <span className="text-xs text-foreground">★ {post.rating.toFixed(1)}</span>
                </div>
              )}
            </Link>

            {/* Author Info */}
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 rounded-full bg-stone-200 flex items-center justify-center">
                <span className="text-xs text-stone-600">{post.authorInitials}</span>
              </div>
              <div className="flex-1">
                <p className="text-sm text-foreground">{post.author}</p>
                <p className="text-xs text-muted-foreground">{post.postedTime}</p>
              </div>
              <button className="text-muted-foreground hover:text-foreground transition-colors">
                <MoreHorizontal className="w-4 h-4" />
              </button>
            </div>

            {/* Content */}
            <div className="mb-4">
              {post.dishName && (
                <h3 className="serif text-2xl mb-2 text-foreground">{post.dishName}</h3>
              )}
              {post.restaurant && (
                <p className="text-sm text-muted-foreground mb-1">{post.restaurant}</p>
              )}
              {post.location && (
                <p className="text-xs text-muted-foreground">{post.location}</p>
              )}
            </div>

            <div className="h-px bg-border mb-4"></div>

            {/* Actions */}
            <div className="flex items-center gap-6">
              <button
                onClick={() => handleFavoriteToggle(post)}
                className={`flex items-center gap-2 transition-colors ${
                  isFavorite(post.id) 
                    ? 'text-red-500' 
                    : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                <Heart className={`w-4 h-4 ${isFavorite(post.id) ? 'fill-current' : ''}`} />
                <span className="text-xs">{post.likes}</span>
              </button>
              <button className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors">
                <MessageCircle className="w-4 h-4" />
                <span className="text-xs">{post.comments}</span>
              </button>
              <button className="ml-auto text-muted-foreground hover:text-foreground transition-colors">
                <Bookmark className="w-4 h-4" />
              </button>
            </div>
          </motion.article>
        ))}
      </div>

      {/* Trending Restaurants */}
      <TrendingRestaurants />

      {/* Seasonal Highlights */}
      <SeasonalHighlights />

      {/* Instagram Feed */}
      <InstagramFeed />

      {/* Most Photographed Dishes */}
      <MostPhotographed period="week" />
    </div>
  );
}

export default FoodFeed;
